// Sidebar.tsx
import React, { useEffect, useRef, useState } from 'react';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
// React Router Dom
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

import logoIcon from "../../../assets/img/icons/logo.svg";
import homeIcon from "../../../assets/img/icons/home-icon.svg";
import homeIconBlack from "../../../assets/img/icons/home-icon-black.svg";
import mapIcon from "../../../assets/img/icons/map-pointer-icon.svg";
import routerIcon from "../../../assets/img/icons/route-icon.svg";

import mapIconBlack from "../../../assets/img/icons/map-pointer-icon-black.svg";
import routerIconBlack from "../../../assets/img/icons/route-icon-black.svg";

import dataPrefIconBlack from "../../../assets/img/icons/data_preferences_black_icon.svg";
import dataPrefIcon from "../../../assets/img/icons/data_preferences_icon.svg";

import userIconBlack from "../../../assets/img/icons/user-icon-black.svg";
import userIcon from "../../../assets/img/icons/user-icon.svg";
import signoutIcon from "../../../assets/img/icons/signout-icon.svg";
import signoutIconBlack from "../../../assets/img/icons/signout-icon-black.svg";

import reportsIconBlack from "../../../assets/img/icons/reports_icon_black.svg";
import reportsIcon from "../../../assets/img/icons/reports_icon.svg";

interface MenuSidebarProps {
  updateSelectedMenu: (selectedMenu: any) => void;
  setDisplayUser: (displayUser: boolean) => void;
  setDisplaySignout: (isSignout:boolean) => void;
}
const MenuSidebar: React.FC<MenuSidebarProps> = (props:MenuSidebarProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const [selectedMenu, setSelectedMenu] = useState(''); // Initial selected menu
  const sidebarRef = useRef<HTMLDivElement>(null);
  const { pathname: path } = useLocation();
    // Handle clicks outside the sidebar
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
          setCollapsed(true);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    useEffect(() => {
      if (path === '/') {
        setSelectedMenu('Home');
      }
      if (path.startsWith('/regulatory-surveys') || path.startsWith('/regulatory-surveys')) {
        setSelectedMenu('regulatory-surveys');
      }
      if (path.startsWith('/asset-summary')) {
        setSelectedMenu('asset-summary');
      }
      if (path.startsWith('/voluntary-surveys')|| path.startsWith('/voluntary-details')) {
        setSelectedMenu('voluntary-surveys');
      }
      if (path.startsWith('/reports')) {
        setSelectedMenu('reports');
      }
    }, [path]);
    
  const navigate = useNavigate();

  const handleMenuItemClick = (menuLabel: string) => {
    setSelectedMenu(menuLabel);
    props.updateSelectedMenu(menuLabel);
    if(menuLabel === "/"){
      navigate(`/`);
    }else{
      navigate(`/${menuLabel}`);
    }
  };
  
  const userPopupHandler = () => {
    props.setDisplayUser(true);
  };
  
  const signoutPopupHandler = () => {
    props.setDisplaySignout(true);
  };
  
  return (
      <Sidebar ref={sidebarRef as any} collapsed={collapsed} transitionDuration={1000}>
        <Menu>
          <MenuItem data-tooltip-id="tooltip-aura-logo">
            <div className='menu-img'><img src={logoIcon} onClick={() => setCollapsed(!collapsed)} /></div>
            <div className='menu-label'> AURA</div>
          </MenuItem>

          <MenuItem active={selectedMenu === '' || selectedMenu === '/' || selectedMenu === 'Home'} data-tooltip-id="tooltip-home-menu" onClick={() => handleMenuItemClick('/')} >
            <div className='menu-img'><img src={(selectedMenu === '' || selectedMenu === '/' || selectedMenu === 'Home') ? homeIconBlack : homeIcon} /></div>
            <div className='menu-label'> Home </div>
          </MenuItem>

          <MenuItem active={selectedMenu === 'regulatory-surveys'} onClick={() => handleMenuItemClick('regulatory-surveys')} 
            data-tooltip-id="tooltip-regulatory-surveys">
            <div className='menu-img'><img src={(selectedMenu === 'regulatory-surveys') ? routerIconBlack : routerIcon} /></div>
            <div className='menu-label'>Regulatory Surveys</div>
          </MenuItem>

          <MenuItem active={selectedMenu === 'voluntary-surveys'} onClick={() => handleMenuItemClick('voluntary-surveys')} data-tooltip-id="tooltip-voluntary-surveys">
            <div className='menu-img'><img src={(selectedMenu === 'voluntary-surveys') ? mapIconBlack : mapIcon} /></div>
            <div className='menu-label'>Voluntary Surveys</div>
          </MenuItem>

          <MenuItem active={selectedMenu === 'reports'} onClick={() => handleMenuItemClick('reports')} data-tooltip-id="tooltip-reports">
            <div className='menu-img'><img src={(selectedMenu === 'reports') ? reportsIconBlack : reportsIcon} /></div>
            <div className='menu-label'>Reports</div>
          </MenuItem>
          
          {/* Asset Summary menu will dispaly only for Super/Global/Customer admins*/}
          {
            <MenuItem active={selectedMenu === 'asset-summary'} onClick={() => handleMenuItemClick('asset-summary')} data-tooltip-id="tooltip-asset-summary">
              <div className='menu-img'><img src={(selectedMenu === 'asset-summary') ? dataPrefIconBlack : dataPrefIcon} /></div>
              <div className='menu-label'>Asset Summary</div>
            </MenuItem>
          }
          {/* Asset Summary menu will dispaly only for Super/Global/Customer admins*/}

          <div className='menu-bottom-icons-container'>
            <MenuItem active={selectedMenu === 'user'} onClick={() => userPopupHandler()} className='user-icon' data-tooltip-id="tooltip-user">
              <div className='menu-img'><img src={(selectedMenu === 'user') ? userIconBlack : userIcon} className='rounded-pill' /></div>
              <div className='menu-label'>User</div>
            </MenuItem>
            <MenuItem active={selectedMenu === 'signout'} onClick={() => signoutPopupHandler()} className='signout-icon' data-tooltip-id="tooltip-signout">
              <div className='menu-img'><img src={(selectedMenu === 'signout') ? signoutIconBlack : signoutIcon}/></div>
              <div className='menu-label'> Signout</div>
            </MenuItem>
          </div>
        </Menu>
      </Sidebar>
  );
};

export default MenuSidebar;
